import { render } from "../views/image.html?vue&type=template&id=3cad232e&ts=true&external"
import script from "../scripts/img.ts?vue&type=script&lang=ts&external"
export * from "../scripts/img.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cad232e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cad232e', __exports__)) {
    api.reload('3cad232e', __exports__)
  }
  
  module.hot.accept("../views/image.html?vue&type=template&id=3cad232e&ts=true&external", () => {
    api.rerender('3cad232e', render)
  })

}


export default __exports__